import React from 'react';
import { FileText } from 'lucide-react';

export default function Terms() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
            <FileText className="w-6 h-6 text-gray-900" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-white">Kullanıcı Sözleşmesi</h1>
            <p className="text-gray-400 mt-1">Son güncelleme: 1 Mart 2024</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">1. Genel Hükümler</h2>
              <p className="text-gray-400">
                Bu kullanıcı sözleşmesi, En Yakın Taksi (“platform”, “biz”, “bizim”) tarafından sunulan hizmetlerin kullanım şartlarını belirler. www.enyakintaksi.app web sitesini veya mobil uygulamamızı kullanarak, aşağıdaki şartları kabul etmiş sayılırsınız.

Bu platform, hiçbir şekilde bir taksi çağırma hizmeti sunmaz. Yalnızca en yakın taksi duraklarını listeleyen bir bilgi platformudur. Kullanıcılar ve taksi durakları arasındaki hizmet ilişkisi, doğrudan kullanıcı ve taksi durağı arasında gerçekleşir.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">2. Hizmet Kullanımı</h2>
              <p className="text-gray-400 mb-4">
               En Yakın Taksi platformunu kullanırken:
	•	Sağlanan bilgilerin yalnızca bilgilendirme amaçlı olduğunu kabul etmiş olursunuz.
	•	Yanıltıcı, yanlış veya hatalı bilgi girilmemesi gerektiğini bilirsiniz.
	•	Platformda listelenen taksi duraklarıyla olan iletişiminizden yalnızca siz sorumlusunuz.

Biz, taksi durakları ve şoförleri ile kullanıcılar arasındaki herhangi bir anlaşmazlıktan sorumlu tutulamayız.
              </p>

            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">4. Fikri Mülkiyet</h2>
              <p className="text-gray-400">
                En Yakın Taksi platformundaki tüm içerikler, tasarım ve veriler bizim mülkiyetimizdedir veya lisanslı olarak kullanılmaktadır.
	•	İçeriğin izinsiz kopyalanması, paylaşılması veya ticari amaçla kullanılması yasaktır.
	•	Platformun herhangi bir içeriği, yazılımı veya verisi izinsiz olarak değiştirilemez veya çoğaltılamaz.

Herhangi bir fikri mülkiyet ihlali tespit edilirse, yasal yollara başvurma hakkımız saklıdır.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">5. Hizmet Değişiklikleri</h2>
              <p className="text-gray-400">
                Biz, En Yakın Taksi platformunun içeriğinde, hizmet kapsamımızda ve erişilebilirliğinde değişiklik yapma hakkını saklı tutarız.

Bu kapsamda:
	•	Taksi duraklarının listesi güncellenebilir.
	•	Bazı ilçeler veya şehirler zamanla eklenebilir veya kaldırılabilir.
	•	Web sitesi ve uygulama hizmetlerinde kesintiler yaşanabilir.

Bu değişikliklerden dolayı kullanıcılara herhangi bir taahhütte bulunulmaz.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">6. Sorumluluk Reddi</h2>
              <p className="text-gray-400">
                	•	En Yakın Taksi, sadece taksi duraklarını listeler. Herhangi bir taksi durağının sunduğu hizmetin kalitesi, güvenliği veya uygunluğu konusunda hiçbir garanti vermez.
	•	Kullanıcı ve taksi durağı arasındaki herhangi bir anlaşmazlıktan sorumlu değiliz.
	•	Platformda yer alan taksi bilgileri, taksi duraklarından alınan verilere dayanmaktadır. En Yakın Taksi, bu bilgilerin doğruluğunu garanti etmez.

Kullanıcılar, taksi durağıyla iletişime geçmeden önce kendi araştırmalarını yapmalıdır.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}